export class MainMenu {
    menuChildItemClass = 'menu-item-has-children';
    menuBackBtn = 'header-menu__back-btn';

    constructor(domElm) {
        this.mainMenu = domElm.parentElement.parentElement;
        this.domElm = domElm;
        this.menuChildItem = this.domElm.querySelectorAll(`.${this.menuChildItemClass}`);

        this.addListener()
    }

    addListener() {
        // Children
        this.menuChildItem.forEach(child => {
            child.querySelector(":first-child").addEventListener("click", () => {
                child.classList.add("open");

                // Close btn
                const btn = child.querySelector(`.${this.menuBackBtn}`);
                if (btn) {
                    btn.addEventListener("click", () => {
                        child.classList.remove("open");
                    })
                }
            })
        })
    }
}
